import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // 라우트가 변경될 때마다 페이지 상단으로 스크롤
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
